import React, { useState, useEffect } from "react";
import TablePagination from "@mui/material/TablePagination";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import { styled } from "@mui/system";
import { ptBR } from "@mui/material/locale";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const CustomTablePagination = styled(TablePagination)(({ theme }) => ({
  "& .MuiTablePagination-input": {
    backgroundColor: "#FFFFFF",
  },
}));

const NewPaginationV3 = ({
  totalItems = 400,
  setRowsPage,
  rowsPage,
  setPageOfTable,
  pageOfTable,
  rowsPerPageOptions = [10, 20, 30, 50, 100, 500],
  onChangePage,
  onChangeRowsPerPage,
  isDisabled = false,
}) => {
  //STATES
  const theme = useTheme();

  const countPagination =
    parseInt(totalItems / rowsPage) + (totalItems % rowsPage !== 0 ? 1 : 0);

  const themeWithLocale = React.useMemo(
    () => createTheme(theme, ptBR),
    [ptBR, theme]
  );

  //USE EFFECTS

  //FUNCTIONS
  const handleChangePage = (event, newPage) => {
    setPageOfTable(newPage - 1);
    const hasOnChangePage = !!onChangePage;
    if (hasOnChangePage) {
      onChangePage(newPage - 1);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const valueOfRowsPerPage = parseInt(event.target.value, 10);
    setRowsPage(valueOfRowsPerPage);
    setPageOfTable(0);
    const hasOnChangeRowsPerPage = !!onChangeRowsPerPage;
    if (hasOnChangeRowsPerPage) {
      onChangeRowsPerPage(valueOfRowsPerPage);
    }
  };

  function defaultLabelDisplayedRows({ from, to, count }) {
    return `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`} itens`;
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <ThemeProvider theme={themeWithLocale}>
        <CustomTablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={totalItems}
          rowsPerPage={rowsPage}
          page={pageOfTable}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={defaultLabelDisplayedRows}
          backIconButtonProps={{ sx: { display: "none" } }}
          nextIconButtonProps={{ sx: { display: "none" } }}
          sx={{ fontFamily: "Inter" }}
          disabled={isDisabled}
        />
      </ThemeProvider>
      <Stack spacing={2}>
        <Pagination
          id="pagination-numbers"
          count={countPagination}
          siblingCount={1}
          color="primary"
          onChange={handleChangePage}
          page={pageOfTable + 1}
          disabled={isDisabled}
        />
      </Stack>
    </div>
  );
};

export default NewPaginationV3;
